var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reason" }, [
    _vm.isCancellationPossible
      ? _c("div", { staticClass: "text" }, [
          _vm._v("\n    Motivo do cancelamento\n\n    "),
          _c("textarea", {
            attrs: {
              placeholder:
                "Por favor, você pode nos dizer um pouco do porque você deseja cancelar a limpeza?",
              rows: "5"
            },
            on: { input: _vm.updateCancellationReason }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isShortNotice || !_vm.isCancellationPossible
      ? _c(
          "div",
          { staticClass: "alert" },
          [
            !_vm.isCancellationPossible
              ? _c("Tip", { attrs: { type: "alert" } }, [
                  _vm._v(
                    "\n      Agendamentos cancelados com menos de 3h de antecedência serão considerados como completo e o profissional receberá o valor integral da limpeza, mesmo que ele não seja recebido.\n    "
                  )
                ])
              : _c("Tip", { attrs: { type: "alert" } }, [
                  _vm._v(
                    "\n      Atenção, cancelamento entre 24h e 3h úteis o cliente perde 1h para que a profissional seja compensada pelo dia de trabalho ocupado.\n    "
                  )
                ]),
            _vm._v(" "),
            _c("router-link", { attrs: { to: { name: "help" } } }, [
              _vm._v("\n      Veja todas as regras de cancelamento aqui\n  ")
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08f6945f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08f6945f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/Components/Actions/Cancellation/CancellationData.vue
// module id = null
// module chunks = 